import { Directive, TemplateRef } from '@angular/core';

@Directive({
  selector: '[mcFormBody]'
})
export class FormBodyDirective {
  constructor(public templateRef: TemplateRef<any>) { }
}
